import { h, ComponentChildren } from "preact";
import "./card.scss";

// https://material.io/components/cards
// todo: suport elevated/filled/outlined styles, and optional media, thumbnail, header, subheader, supporting text, footer

interface Props {
    children: ComponentChildren
    class?: string;
}

export const Card = (props: Props) => (
    <div class={"material-card" + (props.class ? (" " + props.class) : "")}>
        {props.children}
    </div>
)

